// Catalogue des événements socket utilisés par l'app.
// IN  : événements émis par le serveur et écoutés par le client.
// OUT : événements émis par le client vers le serveur.

export const SOCKET_IN = {
  CONNECT: 'connect',
  DISCONNECT: 'disconnect',
  RECONNECT_ATTEMPT: 'reconnect_attempt',
  RECONNECT: 'reconnect',
  RECONNECT_FAILED: 'reconnect_failed',
  ERROR: 'error',
  DUPLICATE_CONNECTION: 'duplicateConnection',

  USER_CONNECTED: 'userConnected',
  USER_CONNECTED_COUNT: 'userConnectedCount',

  INVITATION: 'invitation',
  ROUND_EXIST: 'roundExist',
  HAVE_ROUND_IN_PROGRESS: 'haveRoundInProgres',

  ROUND_CREATED: 'roundCreated',
  NEW_ROUND_CREATED: 'newRoundCreated',
  ROUNDS_TO_DELETE: 'roundsToDelete',
  ROUNDS_TO_UPDATE: 'roundsToUpdate',
  ROUNDS_FETCHED: 'roundsFetched',

  ON_JOIN_ROOM: 'onJoinRoom',
  REMOVE_ROUND: 'removeRound',
  CREATED_ROUND_DB: 'createdRoundDb',
  INITIALISED_ROUND: 'initialisedRound',
  REJECTED_INVITATION: 'rejectedInvitation',
  PENDING_INVITATIONS: 'pendingInvitations',

  CLICKED_POINT: 'clickedPoint',
  POINT_ALREADY_OCCUPIED: 'pointAlreadyOccupied',
  TIMER_UPDATE: 'timerUpdate',
  TIMER_EXPIRED: 'timerExpired',
  GAME_OVER: 'gameOver',
  PLAYER_DISCONNECTED: 'playerDisconnected',
  PLAYER_RECONNECTED: 'playerReconnected',
  ALREADY_GAME_OVER: 'alreadyGameOver',
  QUIT_GAME: 'quitGame',
  JOINED_GAME: 'joinedGame',
  TIMER_GLOBAL: 'timerGlobal',
  TIMER_GLOBAL_EXPIRED: 'timerGlobalExpired',
  TIMER_DISCONNECTED: 'timerDisconected',
  TIMER_DISCONNECTED_EXPIRED: 'timerDisconectedExpired',
  TIMER_SYNC: 'timerSync',
  TIMERS_SNAPSHOT: 'timersSnapshot',
  DELETE_POINT: 'deletePoint',
  SPECTATE_ROUND_SNAPSHOT: 'spectateRoundSnapshot',
  PONG: 'pong',
} as const;

export const SOCKET_OUT = {
  IS_IN_ROOM_IN_PROGRESS: 'isInRoomInProgress',
  IS_ROUND_EXIST: 'isRoundExist',
  REJECT_INVITATION: 'rejectInvitation',
  CANCEL_INVITATION: 'cancelInvitation',

  CREATE_ROUND: 'createRound',
  FETCH_ROUNDS: 'fetchRounds',
  JOIN_ROOM: 'joinRoom',
  INITIALISATION_ROUND: 'intialisationRound',
  REMOVE_ROUND: 'removeRound',

  JOIN_GAME: 'joinGame',
  CLICKED_POINT: 'clickedPoint',
  QUIT_GAME: 'quitGame',
  REQUEST_TIMER_SYNC: 'requestTimerSync',

  USER_CONNECTED: 'userConnected',
  COUNT_USER_CONNECTED: 'countUserConnected',
  SYNC_PENDING_INVITATIONS: 'syncPendingInvitations',
  SPECTATE_ROUND: 'spectateRound',
  LEAVE_SPECTATE_ROUND: 'leaveSpectateRound',
  JOIN_LOBBY: 'joinLobby',
  LEAVE_LOBBY: 'leaveLobby',
  JOIN_PRESENCE: 'joinPresence',
  LEAVE_PRESENCE: 'leavePresence',
  PING: 'ping',
} as const;

export type SocketInEvent = (typeof SOCKET_IN)[keyof typeof SOCKET_IN];
export type SocketOutEvent = (typeof SOCKET_OUT)[keyof typeof SOCKET_OUT];
